// extracted by mini-css-extract-plugin
module.exports = {"advice":"search_advice-module__advice--3bEt4","text":"search_advice-module__text--1lB6G","link":"search_advice-module__link--3-9ZK"};